import { FC, useMemo } from 'react'

import { Nullable } from 'clickNgo/models/utils'
import { Translation } from 'cng-common/features/translations/components/translation'

import { getFormattedFinance } from '../../../../../../../helpers/getFormattedFinance'
import { TRANSLATION_KEYS } from '../../translations'

import styles from './RetailerStoresReadMode.module.scss'

interface IRetailerStoresReadModeProps {
  storesTotal: Nullable<number>
  storesPSHW: Nullable<number>
  storesPRHW: Nullable<number>
}

export const RetailerStoresReadMode: FC<IRetailerStoresReadModeProps> = ({
  storesTotal,
  storesPSHW,
  storesPRHW,
}) => {
  const formattedStoresTotal = useMemo(() => {
    if (storesTotal === null) {
      return '-'
    }

    return getFormattedFinance(storesTotal, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
  }, [storesTotal])

  const formattedStoresPSHW = useMemo(() => {
    if (storesPSHW === null) {
      return '-'
    }

    return getFormattedFinance(storesPSHW, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
  }, [storesPSHW])

  const formattedStoresPRHW = useMemo(() => {
    if (storesPRHW === null) {
      return '-'
    }

    return getFormattedFinance(storesPRHW, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
  }, [storesPRHW])

  return (
    <div className={styles.root}>
      <div className={styles.fieldWrapper}>
        <div className={styles.value}>{formattedStoresTotal}</div>
        <div className={styles.label}>
          <Translation text={TRANSLATION_KEYS.storesTotalLabel} span />
        </div>
      </div>
      <div className={styles.fieldWrapper}>
        <div className={styles.value}>{formattedStoresPSHW}</div>
        <div className={styles.label}>
          <Translation text={TRANSLATION_KEYS.storesPSHWLabel} span />
        </div>
      </div>
      <div className={styles.fieldWrapper}>
        <div className={styles.value}>{formattedStoresPRHW}</div>
        <div className={styles.label}>
          <Translation text={TRANSLATION_KEYS.storesPRHWLabel} span />
        </div>
      </div>
    </div>
  )
}
